import React, { useMemo } from 'react';
import { CommonCustomerItem } from 'types';

import styles from './ProductPage.module.scss';
import { Brands } from '../../components/Brands';
import cx from 'classnames';
import { getFormattedDate } from '../../utils/formatters';
import { RatingMark } from '../../components/RatingMark';

export type PRPostsReviewsProps = {
  posts: Array<CommonCustomerItem>;
  reviews: Array<CommonCustomerItem>;
  onlyPosts?: boolean;
  hideVideo?: boolean;
  hideDivider?: boolean;
  withMinPadding?: boolean;
};
export type PRReviewsProps = {
  reviews: Array<CommonCustomerItem>;
  hideDivider?: boolean;
};

export const PRPostsReviews = ({ posts, reviews, onlyPosts, hideVideo, hideDivider, withMinPadding }: PRPostsReviewsProps) => {
  return (
    <div className={cx(styles.related, hideDivider && styles.hideDivider, withMinPadding && styles.minPadding)}>
      {!hideVideo && (
        <>
          <div className={cx(styles.promoBox, styles.forNotMob)}>
            <video className={styles.promo} playsInline autoPlay muted loop>
              <source src="/promo.mp4" type="video/mp4" />
            </video>
          </div>
          <div className={cx(styles.promoBox, styles.forMob)} onClick={() => window.location.assign('https://onelink.to/sendy')}>
            <video className={styles.promo} playsInline autoPlay muted loop>
              <source src="/promoMob.mp4" type="video/mp4" />
            </video>
          </div>
        </>
      )}
      <div className={cx(styles.relatedItems, withMinPadding && styles.containerPadding)} style={{gap: '1rem'}}>{posts.map((item: CommonCustomerItem) => (
        <Brands
          key={item.id}
          brand={item}
          type={'common'}
          objectFit={'contain'}
          withOpacity={false}
          onClick={() => window.open(item.url)}
          customClass={styles.prPost}
          smallerMobile
          isRawSvg
        />
      ))}</div>
      {onlyPosts || (
        <div className={cx(styles.relatedItems, styles.marginTop, withMinPadding && styles.containerPadding)}>{reviews.map((item: CommonCustomerItem) => (
          <Review
            key={item.id}
            review={item}
          />
        ))}</div>
      )}
    </div>
  );
};

export const PRReviews = ({ reviews, hideDivider }: PRReviewsProps) => {
  return (
    <div className={cx(styles.related, hideDivider && styles.hideDivider, styles.minPadding)}>
      <div className={cx(styles.relatedItems, styles.marginTop)}>{reviews.map((item: CommonCustomerItem) => (
        <Review
          key={item.id}
          review={item}
        />
      ))}</div>
    </div>
  );
};

export const CrowdReviews = ({ reviews }: PRReviewsProps) => {
  return (
    <div className={cx(styles.reviewsGreed)}>
      {reviews.map((item: CommonCustomerItem) => (
        <Review
          key={item.id}
          review={item}
        />
      ))}
    </div>
  );
};

const Review = ({review}) => {

  const { title, description } = useMemo(() => {
    const parts = review.text.split('\n')
    if(parts.length === 1)
      return { title: null, description: review.text }

    const description = parts.filter((a, i) => i!==0).join('\n');
    return { title: parts[0], description }
  }, [review.text])

  return (
    <div className={styles.reviewContainer}>
      <div className={styles.titleRow}>
        <div>
          {!!title && <p className={cx(styles.title, styles.marginBottom)}>{title}</p>}
          <RatingMark className={styles.smallStar} value={+(review.rating || 0)} isOrange />
        </div>
        <div>
          <p className={cx(styles.misc, styles.marginBottom)}>{getFormattedDate(review.reviewed_at, 'DD MON')}</p>
          <p className={styles.misc}>{review.sender}</p>
        </div>
      </div>
      <p className={styles.description}>{description}</p>
    </div>
  )
}
